import { Tooltip as AntToolTip } from "antd";
import "./style.scss";

const Tooltip = ({ children, title = "Tooltip", placement = "bottom" }) => {
  return (
    <AntToolTip title={title} placement={placement}>
      {children}
    </AntToolTip>
  );
};

export default Tooltip;
